export const regexPatterns = {
    email: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,20}$/,
    // phoneNumber: /^\+?[0-9]\d{1,14}$/,
    phoneNumber: /^\+?[0-9]?[0-9](?:\s?\d{2})?\d{0,12}$/,
    mobileRegEx: /^[0-9]{9,15}$/,
    abnAndAcn: /^(?:\d\s*){9}$|^(?:\d\s*){11}$/,
};

export const mobileApp = {
  android: 'https://play.google.com/store/apps/details?id=com.unifiproperty.client',
  ios: 'https://apps.apple.com/au/app/unifi-property/id6648757132'
}



// WEBPACK FOOTER //
// ./src/utils/utils.js